import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=6eef3678&scoped=true"
import script from "./productCard.vue?vue&type=script&lang=js"
export * from "./productCard.vue?vue&type=script&lang=js"
import style0 from "./productCard.vue?vue&type=style&index=0&id=6eef3678&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef3678",
  null
  
)

export default component.exports